export const formInitialValues = (data) => ({
  namaItem: data?.nama_item_sumber_daya ?? "",
  keterangan: data?.keterangan ?? "",
  idSatuan: data?.id_satuan ?? "",
  namaSatuan: data?.nama_satuan ?? "",
  idKategori: data?.id_kategori_anggaran ?? "",
  namaKategori: data?.nama_kategori_anggaran ?? "",
  idItem: data?.id_item_sumber_daya ?? null,
});
